module.exports = __webpack_public_path__ + "static/monochrome_map-818d13c78b4f4e89bdeb528b66892d1b.png";